// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"SubmitButton_submitButton__heHId"};